import { useState, useEffect, useRef } from 'react';
import ToastBanner from './ToastBanner';
import './Toast.css';
import { TOAST_CONSTANTS } from './hooks/useReducedToastQueue';

const ToastStack = ({ toasts, removeToast }) => {
    return (
        <div className="toast-stack">
            {toasts?.map((toast, index) => (
                <ToastMessage key={toast.id} toast={toast} removeToast={removeToast} index={index} />
            ))}
        </div>
    );
};

const ToastMessage = ({ toast, removeToast, index }) => {
    const [isExiting, setIsExiting] = useState(false);
    const timeoutRef = useRef();
    const fadeTimeoutRef = useRef();

    // Handle auto-dismiss (unless disableTimeout is true)
    useEffect(() => {
        if (!toast.disableTimeout) {
            timeoutRef.current = setTimeout(() => {
                setIsExiting(true);
            }, toast.timeout || TOAST_CONSTANTS.TOAST_DURATION);
        }
        return () => clearTimeout(timeoutRef.current);
    }, [toast.timeout, toast.id, toast.disableTimeout]);

    // Remove after fade-out
    useEffect(() => {
        if (isExiting) {
            fadeTimeoutRef.current = setTimeout(() => {
                removeToast(toast.id);
            }, TOAST_CONSTANTS.FADE_DURATION);
        }
        return () => clearTimeout(fadeTimeoutRef.current);
    }, [isExiting, removeToast, toast.id]);

    // Manual dismiss
    const handleManualDismiss = () => {
        setIsExiting(true);
    };

    return (
        <div
            className={`toast-container toast-container-${toast.type} ${isExiting ? 'fade-out' : 'fade-in'}`}
            style={{
                zIndex: 1000 - index,
            }}
        >
            <ToastBanner status={toast.type} onDismiss={handleManualDismiss}>
                {toast.message}
            </ToastBanner>
        </div>
    );
};

export default ToastStack;
